"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var InterfaceTypes = __importStar(require("@microchip/scf-interface"));
var pkgJson = __importStar(require("../package.json"));
var getInterfaceId = function () {
    return {
        name: InterfaceTypes.getInterfaceName(pkgJson),
        version: InterfaceTypes.getInterfaceVersion(pkgJson),
    };
};
exports.sortInitializers = function (initializers) {
    var retinitializers = __spreadArrays(initializers);
    retinitializers.sort(prioritySorter);
    return retinitializers;
};
var prioritySorter = function (a, b) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var result = 0;
    var apriority = (_b = (_a = a === null || a === void 0 ? void 0 : a.initializer) === null || _a === void 0 ? void 0 : _a.priority) !== null && _b !== void 0 ? _b : INIT_PRIORITY.DEFAULT;
    var bpriority = (_d = (_c = b === null || b === void 0 ? void 0 : b.initializer) === null || _c === void 0 ? void 0 : _c.priority) !== null && _d !== void 0 ? _d : INIT_PRIORITY.DEFAULT;
    if (apriority < bpriority) {
        result = -1;
    }
    else if (apriority > bpriority) {
        result = 1;
    }
    else {
        //same priority sort via intializer name alphabetically
        result = (_h = (_f = (_e = a === null || a === void 0 ? void 0 : a.initializer) === null || _e === void 0 ? void 0 : _e.name) === null || _f === void 0 ? void 0 : _f.localeCompare((_g = b === null || b === void 0 ? void 0 : b.initializer) === null || _g === void 0 ? void 0 : _g.name)) !== null && _h !== void 0 ? _h : 0;
    }
    return result;
};
var INIT_PRIORITY;
(function (INIT_PRIORITY) {
    INIT_PRIORITY[INIT_PRIORITY["START"] = 1] = "START";
    INIT_PRIORITY[INIT_PRIORITY["PRE_PERIPHERAL"] = 50] = "PRE_PERIPHERAL";
    INIT_PRIORITY[INIT_PRIORITY["PERIPHERAL"] = 100] = "PERIPHERAL";
    INIT_PRIORITY[INIT_PRIORITY["POST_PERIPHERAL"] = 150] = "POST_PERIPHERAL";
    INIT_PRIORITY[INIT_PRIORITY["DEFAULT"] = 200] = "DEFAULT";
    INIT_PRIORITY[INIT_PRIORITY["PRE_SOFTWARE"] = 250] = "PRE_SOFTWARE";
    INIT_PRIORITY[INIT_PRIORITY["SOFTWARE"] = 300] = "SOFTWARE";
    INIT_PRIORITY[INIT_PRIORITY["POST_SOFTWARE"] = 350] = "POST_SOFTWARE";
    INIT_PRIORITY[INIT_PRIORITY["END"] = 400] = "END";
})(INIT_PRIORITY = exports.INIT_PRIORITY || (exports.INIT_PRIORITY = {}));
var createMock = function () {
    return {
        interfaceId: getInterfaceId(),
        payload: {
            moduleName: "MyModule",
        },
        args: {},
        results: {
            requestId: {
                initializer: {
                    name: "mymodule_init",
                    header: {
                        name: "mymodule.h",
                        path: "include/",
                    },
                },
                registerInit: [
                    {
                        name: "OSCCON1",
                        comment: "//Comments",
                        value: 55,
                        valueAsHex: "0x55",
                    },
                ],
            },
        },
    };
};
var createPrototypeImport = function () {
    return {
        interfaceId: getInterfaceId(),
    };
};
var createPrototypeExport = function () {
    return {
        interfaces: [{ interfaceId: getInterfaceId() }],
    };
};
exports.Interface = {
    createPrototypeExport: createPrototypeExport,
    createPrototypeImport: createPrototypeImport,
    getInterfaceId: getInterfaceId,
    createMock: createMock,
};
//# sourceMappingURL=initializer-system.js.map